var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,9H19V7a1,1,0,0,0-1-1,3.9,3.9,0,0,0-2.016-3.485,4.093,4.093,0,0,0-2.359-.5.593.593,0,0,1-.54-.223,4.509,4.509,0,0,0-7.332.229A3.993,3.993,0,0,0,2,6,1,1,0,0,0,1,7V19a5.006,5.006,0,0,0,5,5h8a5.006,5.006,0,0,0,5-5h.5A3.5,3.5,0,0,0,23,15.5v-3A3.5,3.5,0,0,0,19.5,9ZM6,4a.963.963,0,0,1,.171.021,1,1,0,0,0,1.068-.567A2.5,2.5,0,0,1,11.486,3a2.576,2.576,0,0,0,2.332,1.012,2.157,2.157,0,0,1,1.228.271A1.938,1.938,0,0,1,16,6H12A3,3,0,0,0,9,9v3a1,1,0,0,1-2,0V9A3,3,0,0,0,4,6,2,2,0,0,1,6,4ZM17,19a3,3,0,0,1-3,3H6a3,3,0,0,1-3-3V8H4A1,1,0,0,1,5,9v3a3,3,0,0,0,6,0V9a1,1,0,0,1,1-1h5Zm4-3.5A1.5,1.5,0,0,1,19.5,17H19V11h.5A1.5,1.5,0,0,1,21,12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeer);
export default __webpack_public_path__ + "static/media/beer.8294f17419a4c83280587919d2bc8a1e.svg";
export { ForwardRef as ReactComponent };